module.exports = __webpack_public_path__ + "static/media/md-bookmarks.c2172fa0.svg";